
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Container, Card, Button, InputGroup, } from "react-bootstrap";
import "../../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import Select from "react-select";

const HODWaiverLimit = () => {
  // ----------------------------------------
  // Mode
  // ----------------------------------------
  const [isEditable, setIsEditable] = useState(false);

  // null = no row selected
  // number = selected table row index
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  // ----------------------------------------
  // Dropdowns
  // ----------------------------------------
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);
  const [empIds, setEmpIds] = useState([]);

  // ----------------------------------------
  // Validation
  // ----------------------------------------
  const [errors, setErrors] = useState({});

  // ----------------------------------------
  // Header State
  // ----------------------------------------
  const [headerData, setHeaderData] = useState({
    irn: "",
    year1: "",
    year2: "",
    emp_id: "",
    emp_name: "",
    fw_plan_limit: "",
    fw_act_limit: "",
    status: "A",
  });

  // ----------------------------------------
  // Table Data
  // ----------------------------------------
  const [childRows, setChildRows] = useState([]);

  // ----------------------------------------
  // Load dropdown data
  // ----------------------------------------
  useEffect(() => {
    const fetchLists = async () => {
      try {
        const yearResult = await axios.get(`${BASE_URL}/api/ddl_open_year`);

        setDdlAcademicYears(yearResult.data || []);

        if (yearResult.data && yearResult.data.length > 0) {
          setHeaderData((prev) => ({
            ...prev,
            year1: yearResult.data[0].year1,
            year2: Number(yearResult.data[0].year1) + 1,
          }));
        }

        const empResult = await axios.get(`${BASE_URL}/api/ddl_supervisors`);

        setEmpIds(empResult.data || []);

        populateGrid();

      } catch (err) {
        console.error("Dropdown fetch error:", err);
        toast.error("Unable to load dropdown data.");
      }
    };

    fetchLists();
  }, []);

  const populateGrid = async () => {

    try {

      setChildRows([]);

      const result = await axios.get(`${BASE_URL}/api/get_hod_fw_limit`);

      setChildRows(result.data);

    } catch (err) {
      console.error("Dropdown fetch error:", err);
      toast.error("Unable to load populateGrid.");
    }

  }

  // ----------------------------------------
  // Employee options
  // ----------------------------------------
  const options_emp = empIds.map((emp) => ({
    value: emp.emp_id,
    label: emp.emp_name,
  }));

  // ----------------------------------------
  // Header change
  // ----------------------------------------
  const handleHeaderChange = (e) => {
    const { name, value } = e.target;

    if (name === "year1") {
      setHeaderData((prev) => ({ ...prev,
        year1: value,
        year2: Number(value) + 1,
      }));
    } else {
      setHeaderData((prev) => ({ ...prev, [name]: value, }));
    }

    setErrors((prev) => ({ ...prev, [name]: "", }));

  };

  // ----------------------------------------
  // Employee change
  // ----------------------------------------
  const handleEmployeeChange = (selectedOption) => {
    setHeaderData((prev) => ({
      ...prev,
      emp_id: selectedOption ? selectedOption.value : "",
      emp_name: selectedOption ? selectedOption.label : "",
    }));

    setErrors((prev) => ({
      ...prev,
      emp_id: "",
    }));
  };

  // ----------------------------------------
  // Amount change
  // ----------------------------------------
  const handleAmountChange = (e) => {

    const { name, value } = e.target;

    // Remove everything except numbers and decimal point
    let cleanedValue = value.replace(/[^0-9.]/g, "");

    // Allow only one decimal point
    const parts = cleanedValue.split(".");
    if (parts.length > 2) {
      cleanedValue = parts[0] + "." + parts.slice(1).join("");
    }

    // Maximum 2 decimal places
    if (parts[1] && parts[1].length > 2) {
      cleanedValue = parts[0] + "." + parts[1].substring(0, 2);
    }

    setHeaderData((prev) => ({
      ...prev,
      [name]: cleanedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // ----------------------------------------
  // Format amount on blur
  // ----------------------------------------
  const handleAmountBlur = (e) => {

    const { name, value } = e.target;

    if (!value) return;

    const numericValue = parseFloat(String(value).replace(/,/g, ""));

    if (isNaN(numericValue)) return;

    const formatted = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);

    setHeaderData((prev) => ({
      ...prev,
      [name]: formatted,
    }));

  };

  // ----------------------------------------
  // New
  // ----------------------------------------
  const handleNew = () => {
    setSelectedRowIndex(null);

    setHeaderData((prev) => ({
      ...prev,
      irn: "",
      emp_id: "",
      emp_name: "",
      fw_plan_limit: "",
      fw_act_limit: "",
      status: "A",
    }));

    setErrors({});
    setIsEditable(true);
  };

  // ----------------------------------------
  // Table row click
  // ----------------------------------------
  const handleRowClick = (index) => {

    const row = childRows[index];

    if (row.open_close === 'C') {
      toast.warning('Cannot edit closed year Limit!');
      return;
    }

    setSelectedRowIndex(index);

    setHeaderData((prev) => ({
      ...prev,
      irn: row.irn,
      emp_id: row.emp_id || "",
      emp_name: row.emp_name || "",
      fw_plan_limit: formatAmount(row.fw_plan_limit) || "",
      fw_act_limit: formatAmount(row.util_limit) || "",
      status: row.status || "A",
    }));

    // Row is selected but not editable until Edit is clicked
    setIsEditable(true);
    setErrors({});
    
  };

  // ----------------------------------------
  // Clear
  // ----------------------------------------
  const handleClear = () => {
    if (!window.confirm("Clear all data?")) {
      return;
    }

    resetPage();
  };

  // ----------------------------------------
  // Reset
  // ----------------------------------------
  const resetPage = () => {
    setSelectedRowIndex(null);
    setIsEditable(false);
    setErrors({});

    setHeaderData((prev) => ({
      ...prev,
      irn: "",
      emp_id: "",
      emp_name: "",
      fw_plan_limit: "",
      fw_act_limit: "",
      status: "A",
    }));
  };

  // ----------------------------------------
  // Validation
  // ----------------------------------------
  const validateHeader = () => {
    const newErrors = {};

    if (!headerData.year1) {
      newErrors.year1 = "Error";
      toast.error("Please select Academic Year.");
    }

    if (!headerData.emp_id) {
      newErrors.emp_id = "Error";
      toast.error("Please select Employee.");
    }

    if (
      headerData.fw_plan_limit === "" ||
      headerData.fw_plan_limit === null
    ) {
      newErrors.fw_plan_limit = "Error";
      toast.error("Please enter Planned Waiver Limit.");
    }

    return newErrors;

  };

  // ----------------------------------------
  // Save
  // ----------------------------------------
  const handleSave = async () => {

    // if (!isEditable) {
    //   toast.warning("Please click New or Edit before saving.");
    //   return;
    // }

    const newErrors = validateHeader();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // ----------------------------------------
    // Duplicate employee validation
    // ----------------------------------------

    const duplicateIndex = childRows.findIndex(
      (row, index) =>
        String(row.emp_id).trim() === String(headerData.emp_id).trim() &&
        String(row.year1).trim() === String(headerData.year1).trim() &&
        index !== selectedRowIndex
    );

    if (duplicateIndex !== -1) {
      setErrors((prev) => ({ ...prev, emp_id: "Error", }));
      toast.error("The selected HOD is already assigned a Limit.");
      return;
    }

    const isConfirmed = window.confirm("Save the new record?");
    if (!isConfirmed) return;

    try {
      const hodLimitData = {
        header: {
          irn: headerData.irn,
          year1: headerData.year1,
          year2: headerData.year2,
          emp_id: headerData.emp_id,
          status: headerData.status,
          plan_limit: headerData.fw_plan_limit
        }
      };

      const response = await axios.post(`${BASE_URL}/api/save_hod_fw_lmt`, hodLimitData);

      if (response.data.message === "1") {
        populateGrid();
        toast.success("HOD Waiver Limit saved successfully.");
        resetPage();
      } else {
        toast.error("Unable to Save Limit.");
      }

    } catch (err) {
      console.error("Save error:", err);
      toast.error("Unable to save record.");
    }


  };

  const formatAmount = (amount) =>
    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  // ----------------------------------------
  // Selected employee
  // ----------------------------------------
  const selectedEmployee = options_emp.find(
      (option) => String(option.value) === String(headerData.emp_id) ) || null;

  return (

    <Container fluid className="p-3">

      {/* =====================================================
          HEADER / EDIT SECTION
      ====================================================== */}
      <Card className="mb-4 p-3">

        <Row className="mb-3">

          {/* Academic Year */}
          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}> Academic Year{" "}
                <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>

              <select className={`form-select ${errors.year1 ? "is-invalid" : "" }`}
                name="year1" value={headerData.year1} onChange={handleHeaderChange}
                disabled={!isEditable} >
                {/* <option value="">
                  -- Select Year --
                </option> */}
                {ddlAcademicYears.map((y) => (
                  <option key={y.year1} value={y.year1} > {y.disp_year} </option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={4}></Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}>
                Status
              </InputGroup.Text>

              <select className="form-select" name="status"
                value={headerData.status} onChange={handleHeaderChange}
                disabled={!isEditable} >
                <option value="A"> Active </option>
                <option value="I"> Inactive </option>
              </select>

            </InputGroup>
          </Col>


        </Row>

        {/* =====================================================
            EMPLOYEE
        ====================================================== */}
        <Row className="mb-3">

          <Col md={12}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}>
                Employee{" "}
                <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>

              <div style={{ flex: 1 }}>

                <Select inputId="emp_id" classNamePrefix="react-select"
                  className={ errors.emp_id ? "react-select-error" : "" }
                  options={options_emp} value={selectedEmployee}
                  onChange={handleEmployeeChange} isDisabled={!isEditable}
                  placeholder="-- Select HOD --" 
                  // menuPortalTarget={document.body}
                  // styles={{ menuPortal: (base) => ({
                  //     ...base,
                  //     zIndex: 9999,
                  //   }),
                  // }}
                />

              </div>
            </InputGroup>
          </Col>


        </Row>

        {/* =====================================================
            STATUS
        ====================================================== */}
        <Row>

          {/* Planned Waiver Limit */}
          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}> Plan Limit <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>

              <input type="text" inputMode="decimal"
                className={`form-control ${errors.fw_plan_limit ? "is-invalid" : ""}`}
                name="fw_plan_limit" value={headerData.fw_plan_limit}
                onChange={handleAmountChange} onBlur={handleAmountBlur}
                disabled={!isEditable} style={{ textAlign: "right" }}
              />
            </InputGroup>
          </Col>

          {/* Actual Waiver Limit */}
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text> Utilized Limit
              </InputGroup.Text>

              <input type="text" className="form-control" name="fw_act_limit"
                value={headerData.fw_act_limit} onChange={handleAmountChange}
                onBlur={handleAmountBlur} disabled
                style={{ textAlign: "right" }}
              />
            </InputGroup>
          </Col>

          {/* {selectedRowIndex !== null && (
            <Col md={8}>
              <div className="text-muted text-end mt-2">
                Selected Row: {selectedRowIndex + 1}
                {!isEditable && (
                  <span>
                    {" "}— Click <b>Edit</b> to modify
                  </span>
                )}
              </div>
            </Col>
          )} */}

          {/* Buttons */}
          <Col md={5}>
            <div className="d-flex justify-content-end gap-2 flex-wrap">

              <button type="button" className="btn btn-primary" style={{ width: "135px" }} 
                      onClick={handleNew} disabled={isEditable} > New
              </button>

              <button type="button" className="btn btn-secondary" style={{ width: "135px" }}
                onClick={handleClear} > Clear
              </button>

              <button type="button" className="btn btn-success" style={{ width: "135px" }}
                onClick={handleSave} disabled={!isEditable} > Save
              </button>

            </div>
          </Col>

        </Row>

      </Card>


      {/* =====================================================
          DISPLAY TABLE
      ====================================================== */}
      <Card className="p-3">

        <div style={{ minHeight: "220px" }} className="table-wrapper" >

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table" >

            <thead>
              <tr>
                <th style={{ width: "8%", textAlign: "left", }} > Year </th>
                <th style={{ width: "40%", textAlign: "left", }} > Employee </th>
                <th style={{ width: "12%", textAlign: "right", }} > Plan Limit</th>
                <th style={{ width: "12%", textAlign: "right", }} > Utilized Limit </th>
                <th style={{ width: "12%", textAlign: "right", }} > Available Limit </th>
                <th style={{ width: "10%", textAlign: "center", }} > Status </th>
                {/* <th style={{ width: "5%", textAlign: "center", }} > </th> */}
              </tr>
            </thead>

            <tbody>

              {childRows.length === 0 ? (

                <tr>
                  <td colSpan="6" style={{ textAlign: "center", padding: "30px", color: "#888", }} >
                    No records found. <br /> Click <b>New</b> to add a record.
                  </td>
                </tr>
              ) : (

                childRows.map((row, index) => (

                  <tr key={index} onClick={() => handleRowClick(index) }
                    style={{ cursor: "pointer", backgroundColor: selectedRowIndex === index ? "#e7f1ff" : "transparent", }} >

                    <td style={{ textAlign: "center", }} > {row.disp_year} </td>
                    <td> {row.emp_name} </td>
                    <td style={{ textAlign: "right", }} > {formatAmount(row.fw_plan_limit)} </td>
                    <td style={{ textAlign: "right", }} > {formatAmount(row.util_limit)} </td>
                    <td style={{ textAlign: "right", }} > {formatAmount(row.avail_limit)} </td>
                    <td style={{ textAlign: "center", }} >
                      {row.status === "A"
                        ? "Active"
                        : "Inactive"}
                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

      </Card>

    </Container>
  );
};

export default HODWaiverLimit;
